import { render, staticRenderFns } from "./PartnersTradesmanList.vue?vue&type=template&id=1cee1150&"
import script from "./PartnersTradesmanList.vue?vue&type=script&lang=js&"
export * from "./PartnersTradesmanList.vue?vue&type=script&lang=js&"
import style0 from "./PartnersTradesmanList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports